export const BUSINESS = {
  name: "B&C Junk Removal Pros",
  tagline: "Syracuse Strong. Junk Gone.",
  phoneDisplay: "(315) 288-6276",
  phoneHref: "tel:+13152886276",
  hours: "Open Sat & Sun, 8am – 8pm",
  logo:
    "https://customer-assets.emergentagent.com/job_haul-it-demo/artifacts/tzem8oio_D94B4990-7A52-4C1B-86AF-AA1E42BFA22F.png",
  facebook: "https://www.facebook.com/share/18Pdfx5Arn/?mibextid=wwXIfr",
  instagram: "https://instagram.com/briantalksai",
};

export const SERVICES = [
  {
    key: "residential",
    title: "Residential Junk Removal",
    desc: "One item or a whole house. We lift, load, and haul it away — no mess left behind.",
    icon: "Home",
  },
  {
    key: "commercial",
    title: "Commercial & Office Cleanouts",
    desc: "Offices, retail, warehouses. Fast turnarounds that keep your business moving.",
    icon: "Building2",
  },
  {
    key: "estate",
    title: "Estate & Foreclosure Cleanouts",
    desc: "Respectful, thorough clearouts for estates, rentals, and bank-owned properties.",
    icon: "KeyRound",
  },
  {
    key: "cleanouts",
    title: "Garage, Attic & Basement",
    desc: "Years of buildup gone in hours. We handle the heavy stuff and the dust.",
    icon: "Archive",
  },
  {
    key: "appliances",
    title: "Appliance & Furniture Removal",
    desc: "Fridges, couches, mattresses, treadmills — anything bulky, anywhere in the home.",
    icon: "Sofa",
  },
  {
    key: "debris",
    title: "Construction Debris & Yard Waste",
    desc: "Drywall, lumber, branches, sod. Cleared out and disposed of the right way.",
    icon: "TreeDeciduous",
  },
  {
    key: "demo",
    title: "Light Demolition",
    desc: "Sheds, decks, fences, interior walls, flooring. We tear it down and haul it out.",
    icon: "Hammer",
  },
];

export const SERVICE_OPTIONS = [
  "Residential Junk Removal",
  "Commercial & Office Cleanouts",
  "Estate & Foreclosure Cleanouts",
  "Garage, Attic & Basement Cleanouts",
  "Appliance & Furniture Removal",
  "Construction Debris & Yard Waste",
  "Light Demolition",
  "Not sure — need advice",
];

export const TOWNS = [
  "Syracuse",
  "Liverpool",
  "Cicero",
  "Camillus",
  "Baldwinsville",
  "Fulton",
  "Auburn",
  "Oswego",
  "Rome",
  "Utica",
];

export const HERO_BG =
  "https://images.unsplash.com/photo-1751054631354-a42bd7609d75?auto=format&fit=crop&w=2000&q=80";

export const GALLERY_PAIRS = [
  {
    label: "Garage Cleanout — Liverpool, NY",
    before:
      "https://images.unsplash.com/photo-1558317374-067fb5f30001?auto=format&fit=crop&w=1400&q=80",
    after:
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1400&q=80",
  },
  {
    label: "Basement Haul-Out — Cicero, NY",
    before:
      "https://images.unsplash.com/photo-1558002038-1055907df827?auto=format&fit=crop&w=1400&q=80",
    after:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1400&q=80",
  },
  {
    label: "Yard Waste Removal — Camillus, NY",
    before:
      "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=1400&q=80",
    after:
      "https://images.unsplash.com/photo-1558944351-c36a5c7f6acf?auto=format&fit=crop&w=1400&q=80",
  },
  {
    label: "Shed Demo — Baldwinsville, NY",
    before:
      "https://images.unsplash.com/photo-1595872018818-97555653a011?auto=format&fit=crop&w=1400&q=80",
    after:
      "https://images.unsplash.com/photo-1572120360610-d971b9d7767c?auto=format&fit=crop&w=1400&q=80",
  },
];

export const CREW_PHOTO =
  "https://images.pexels.com/photos/17727710/pexels-photo-17727710.jpeg?auto=compress&cs=tinysrgb&w=1600";

export const SERVICE_AREA_BG =
  "https://images.pexels.com/photos/34204678/pexels-photo-34204678.jpeg?auto=compress&cs=tinysrgb&w=1600";
